import { render, staticRenderFns } from "./ActivityPeriods.vue?vue&type=template&id=2a83e824&scoped=true&"
import script from "./ActivityPeriods.vue?vue&type=script&lang=js&"
export * from "./ActivityPeriods.vue?vue&type=script&lang=js&"
import style0 from "./ActivityPeriods.vue?vue&type=style&index=0&id=2a83e824&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a83e824",
  null
  
)

export default component.exports